import { useNavigate } from 'react-router';
import { Link } from '#components/atoms/link/Link.tsx';
import { MainLayout } from '#components/patterns/layouts/main/MainLayout.tsx';
import { PageCloser } from '#components/patterns/page-closer/PageCloser.tsx';
import { PageHeader } from '#components/patterns/page-header/PageHeader.tsx';
import type { NewKeyState } from '#screens/settings/api-keys/types.ts';
import { fromArray, Titled } from '#util/title.ts';
import { APIKeyForm } from '../form/APIKeyForm.tsx';

export function AddAPIKeyPage() {
  const navigate = useNavigate();

  function showToken(newKey: NewKeyState) {
    void navigate({ pathname: '/settings/api-keys', search: location.search }, { state: { newKey }, replace: true });
  }

  return (
    <Titled title={(title) => fromArray(['Add', title])}>
      <MainLayout
        header={
          <PageHeader
            title={
              <>
                <Link to="/settings/api-keys" className="a">
                  API keys
                </Link>
                {' / '}
                Add
              </>
            }
          >
            <PageCloser fallbackTo="/settings/api-keys" />
          </PageHeader>
        }
      >
        <APIKeyForm id={null} onSuccess={showToken} />
      </MainLayout>
    </Titled>
  );
}
